// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__xfBC9","col":"styles_col__3mtRy"};